export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-950">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[720px] mx-auto">
          <div className="bg-[#f5f0e8] rounded-2xl p-8 md:p-12 text-center">
            <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-background-950 flex items-center justify-center">
              <i className="ri-smartphone-line text-3xl text-primary-400 w-8 h-8 flex items-center justify-center"></i>
            </div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-950/10 rounded-full mb-4">
              <span className="text-xs font-semibold text-background-950">APP 极速入口</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
              移动端吃瓜通道
            </h2>
            <p className="text-sm text-foreground-600 mb-8 max-w-[400px] mx-auto">
              随时随地，凌晨更新自动推送。不错过任何一条猛料，手机在手，吃瓜自由。
            </p>
            <button className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm font-bold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer border-0">
              立即打开
              <i className="ri-arrow-right-up-line text-lg w-4 h-4 flex items-center justify-center"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}